
<template>

  <svg viewBox="0 0 50 50" aria-hidden="true">

    <path d="m21.8535 28.2786c-0.287092-0.264125-0.470831-0.424897-0.648829-0.597153-1.65365-1.65365-3.3073-3.30156-4.95521-4.96096-1.1656-1.17134-1.48714-1.17134-2.68144 0.02297-0.677538 0.677538-1.36082 1.34359-2.02687 2.03261-0.643087 0.660312-0.666055 1.26895-0.02871 1.90629 3.10634 3.10634 6.21268 6.20694 9.33624 9.30179 0.677538 0.671796 1.20005 0.65457 1.89481-0.04019 5.74759-5.71888 11.4837-11.4492 17.2255-17.1796 0.700505-0.694764 0.694764-1.26321 0.0057-1.96371-0.729214-0.74644-1.46991-1.47565-2.21061-2.21061-0.947405-0.941663-1.38378-0.935921-2.32545 0-3.20395 3.20969-6.4079 6.41364-9.60611 9.62334-1.32637 1.33211-2.63551 2.68144-3.98484 4.05949z"
    
      fill="#848484" />

  </svg>

</template>
